export default function defaultState() {
  return {
    sectionsList: [],
    customFields: [],
    functionsConfigurations: [],
    entitiesConditions: [],
  }
}
